import { useFormContext } from 'react-hook-form';
import { ChatConversationSchema } from './type';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import { NumericFormat } from 'react-number-format';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

type PlaygroundTextGenerationSettingProps = {
  models: string[];
};

const PlaygroundTextGenerationSetting = ({
  models,
}: PlaygroundTextGenerationSettingProps) => {
  const form = useFormContext<ChatConversationSchema>();
  return (
    <>
      <FormField
        control={form.control}
        name="models"
        render={({ field: { onChange, value, ...fields } }) => (
          <FormItem>
            <FormLabel>Models</FormLabel>
            <FormControl>
              <Select
                onValueChange={(value) => onChange(value)}
                value={value}
                disabled={!models?.length}
                {...fields}
              >
                <SelectTrigger>
                  <SelectValue placeholder={!models?.length ? "Loading..." : "Select a model"} />
                </SelectTrigger>
                <SelectContent>
                  {models?.map((model) => (
                    <SelectItem key={model} value={model}>
                      {model}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="temperature"
        render={({ field: { onChange, value, ...fields } }) => (
          <FormItem>
            <FormLabel>Temperature</FormLabel>
            <FormControl>
              <NumericFormat
                customInput={Input}
                thousandSeparator
                allowNegative={false}
                {...fields}
                value={value}
                onValueChange={(v) => {
                  if (v.floatValue === undefined) onChange(null);
                  else onChange(v.floatValue);
                }}
                placeholder=""
              />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="maxTokens"
        render={({ field: { onChange, value, ...fields } }) => (
          <FormItem>
            <FormLabel>Max completion tokens</FormLabel>
            <FormControl>
              <NumericFormat
                customInput={Input}
                thousandSeparator
                allowNegative={false}
                {...fields}
                value={value}
                onValueChange={(v) => {
                  if (v.floatValue === undefined) onChange(null);
                  else onChange(v.floatValue);
                }}
                placeholder=""
              />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="systemPrompt"
        render={({ field }) => (
          <FormItem>
            <FormLabel>System prompt</FormLabel>
            <FormControl>
              <Textarea placeholder="Type your message here." {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    </>
  );
};

export default PlaygroundTextGenerationSetting;
